import React, { useState } from "react";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import { toast } from "react-toastify";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import MuiButton from "../../../shares/MuiButton";
import MuiModal from "../../../shares/MuiModal";
import CloseIcon from "@mui/icons-material/Close";

// import JS files
import useFetch from "../../../../context/useFetch";
import { useUserData } from "../../../../context/UserDataContext";
import PanelTemplate from "../../../shares/PanelTemplate";
import PanelFilter from "../../../shares/PanelFilter";
import MuiPagination from "../../../shares/MuiPagination";
import PanelTable from "../../../shares/PanelTable";
import OrderDetails from "./OrderDetails";
import { useSetting } from "../../../../context/SettingContext";
// import { showNumSix } from "../../../../constants/constants";
import SelectiveOrderModal from "./SelectiveOrderModal";

const headersList = [
  { colName: "unique_id", name: " سند" },
  { colName: "created_at", name: "تاریخ ثبت سفارش" },
  { colName: "total", name: "وزن" },
  { colName: "details", name: "جزییات سفارش" },
];
const mobileHeadersList = [
  { colName: "name", name: "تولید کننده" },
  { colName: "unique_id", name: " سند" },
  { colName: "created_at", name: "تاریخ ثبت سفارش" },
  { colName: "total", name: "وزن" },
];

const dataKey = ["unique_id", "created_at", "total"];

// import Others files
const CurrentOrders = (props) => {
  let windowWidth = window.screen.width;
  const { showNumSix } = useSetting();
  const { userData } = useUserData();

  const [isFilterOn, setIsFilterOn] = useState(false);
  const [factorNum, setFactorNum] = useState("");
  const [dateFilter, setDateFilter] = useState(null);
  const [openShowInfoModal, setOpenShowInfoModal] = useState(false);

  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 30,
    count: 0,
  });

  const [requestList, setRequestList] = useState({ results: [] });
  const getRequestListApi = useFetch({
    method: "get",
    url: `User_Service/${userData.username}/provider_get_onprogress_admin_request`,
    trigger: true,
    params: {
      date: dateFilter,
    },
    pagination: paginationPageInfo,
    setter: setRequestList,
    argFunc: (res) => {},
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  // Filter
  const filterList = [
    {
      type: "datePicker",
      label_fa: "تاریخ ثبت سفارش",
      label_en: "date",
      state: dateFilter,
    },
  ];

  // Table
  const buttonsList = [
    {
      label: "مشاهده جزییات",
      component: (it) => (
        <OrderDetails selectedRow={it} getRequestListApi={getRequestListApi} />
      ),
    },
  ];

  const update_filter = (state, e) => {
    if (state == "date") setDateFilter(e);
  };
  const filter = () => {
    if (dateFilter !== null) {
      setIsFilterOn(true);
      getRequestListApi.reFetch();
    }
  };
  const reset_filter = () => {
    setDateFilter(null);
  };
  const onChangePage = (e, page) => {
    setPaginationPageInfo({
      ...paginationPageInfo,
      current: page,
    });
    setRequestList({ results: [] });

    getRequestListApi.reFetch();
  };

  const [status, setStatus] = useState("all");
  const [ids, setIds] = useState([]);
  const confirmPreOrdersApi = useFetch({
    method: "post",
    url: `Bangle_Service/provider_onprogress_tab_automatic_factor`,
    data: {
      status: status,
      ids: ids,
      factorNum: factorNum,
    },
    trigger: false,
    argFunc: (res) => {
      setRequestList({ results: [] });

      getRequestListApi.reFetch();
      setOpenShowInfoModal(false);
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const handlePreOrders = () => {
    // confirmPreOrdersApi.reFetch();
    setOpenShowInfoModal(true);
  };

  const confirm_create = (status = "all") => {
    if (status == "all") {
      setIds(requestList.results.filter((it) => it.id));
    }
    setStatus(status);
    confirmPreOrdersApi.reFetch();
  };

  const update_ids = (item_id) => {
    let before = [...ids];
    if (before.includes(item_id)) {
      setIds(before.filter((i) => i !== item_id));
    } else {
      before.push(item_id);
      setIds(before);
    }
  };
  return (
    <>
      {openShowInfoModal && (
        <MuiModal
          openModal={openShowInfoModal}
          setOpenModal={setOpenShowInfoModal}
          width="w-4/5"
        >
          <div className="close-modal-icon">
            <CloseIcon
              onClick={() => setOpenShowInfoModal(false)}
              fontSize="large"
              color="secondary"
            />
          </div>
          <SelectiveOrderModal
            confirm_create={confirm_create}
            update_ids={update_ids}
            ids={ids}
            data={requestList.results}
            confirmPreOrdersApi={confirmPreOrdersApi}
            factorNum={factorNum}
            setFactorNum={setFactorNum}
          />
        </MuiModal>
      )}
      <PanelFilter
        header="فیلتر براساس‌ تاریخ ثبت سفارش:"
        list={filterList}
        update_filter={update_filter}
        filter={filter}
        reset_filter={reset_filter}
      />
      <div className="flex justify-end">
        <MuiButton
          onClick={handlePreOrders}
          variant="outlined"
          icon={<ThumbUpOffAltIcon />}
          color="secondary"
          text="ثبت سفارش"
          margin="mr-2"
        />
        {/* <MuiButton
              onClick={handelPrintReport}
              variant="outlined"
              icon={<PrintIcon />}
              color="primary"
              text="چاپ گزارش"
              margin="mr-2"
            /> */}
      </div>
      <PanelTable
        header="لیست سفارش‌های جاری:"
        headers={headersList}
        mobileHeaders={mobileHeadersList}
        data={requestList.results}
        dataKey={dataKey}
        buttons={buttonsList}
        actions={[]}
        icon={<AddShoppingCartIcon />}
      />

      <MuiPagination
        onChange={onChangePage}
        count={Math.ceil(
          paginationPageInfo.count / paginationPageInfo.pageSize
        )}
      />
    </>
    //   </PanelTemplate>
    // </>
  );
};

export default CurrentOrders;
